import { createContext, useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { isZodFormReturn, type UseZodFormReturn } from './useZodForm';

// React Hook Form's `<FormProvider>` destructures only the specific RHF
// properties it knows about (`register`, `setValue`, `formState`, etc.) and
// drops every extra property — so any `UseZodQueryReturn`-specific fields
// (`queryValues`, `setPartial`, `clear`, `schema`) are stripped at the context
// boundary. We carry those extras through a parallel context so consumers like
// `TableFilterButtons` can still read them.
export const ZodFormContext = createContext<UseZodFormReturn | undefined>(undefined);

export function useZodFormContext(): UseZodFormReturn | undefined {
  const zodForm = useContext(ZodFormContext);
  if (zodForm) return zodForm;

  // Fallback for consumers that aren't wrapped in our provider but still go
  // through RHF's `FormProvider` directly.
  const form = useFormContext();
  if (isZodFormReturn(form)) {
    return form;
  }
}
